import type { ProjectIconKind } from './projectIcon'

/*
  Was der Icon-Wähler sich **pro Gerät** merkt (entschieden 2026-09-25):
  die zuletzt gewählten Icons je Art, den Hautton und die Farbe der
  Lucide-Icons. Nichts davon ist Projekt-Wissen, also nicht im Sync.
*/

const PREFIX = 'happytask.iconPicker.'
export const RECENT_LIMIT = 12

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    return raw ? (JSON.parse(raw) as T) : fallback
  } catch {
    return fallback
  }
}

function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // Kein Speicher (privates Fenster) — dann merkt er sich eben nichts.
  }
}

/** Die zuletzt gewählten Icons einer Art, neuestes zuerst (volle `icon`-Strings). */
export function getRecentIcons(kind: ProjectIconKind): string[] {
  const list = read<unknown>(`recent.${kind}`, [])
  return Array.isArray(list) ? list.filter((x): x is string => typeof x === 'string').slice(0, RECENT_LIMIT) : []
}

export function pushRecentIcon(kind: ProjectIconKind, icon: string): string[] {
  const next = [icon, ...getRecentIcons(kind).filter(x => x !== icon)].slice(0, RECENT_LIMIT)
  write(`recent.${kind}`, next)
  return next
}

export type SkinTone = 'none' | 'light' | 'medium-light' | 'medium' | 'medium-dark' | 'dark'

export const getSkinTone = (): SkinTone => read<SkinTone>('skinTone', 'none')
export const setSkinTone = (tone: SkinTone) => write('skinTone', tone)

/** Die Farbe der Lucide-Icons; `null` = Ton des Lebensbereichs. */
export const getLucideColor = (): string | null => read<string | null>('lucideColor', null)
export const setLucideColor = (color: string | null) => write('lucideColor', color)
